import { Component, OnInit, Input } from '@angular/core';
import { MessagingService } from '../../../services/messaging.service';
import { Globals } from '../../../globals';

@Component({
  selector: 'app-note-example',
  templateUrl: './note-example.component.html',
  styleUrls: ['./note-example.component.css']
})
export class NoteExampleComponent implements OnInit {

  @Input() show: boolean = true;

  notesWindowId: string;
  isPopupMode: boolean = false;

  ObjectId: string = '';
  ParentObjectName: string = '';
  patientName: string = '';
  patientId: string = '';
  //objectId: string = 'C7EF5F71-28E3-E611-8289-001018350ACD';

  messagingSubscription: any;

  constructor(
    private messagingService: MessagingService,
    public globals: Globals,
  ) { }

  ngOnInit() {

    this.patientId = this.globals.currentPatientId;
    this.patientName = this.globals.currentPatientFullName;

    this.ObjectId = null;
    this.ParentObjectName = 'dataPatient';

    // ADD THIS BACK

    if (this.globals.currentPatientCaseId) {
      this.ObjectId = this.globals.currentPatientCaseId;
      this.ParentObjectName = 'dataPatientCase';
    } else {
      this.ObjectId = null;
      this.ParentObjectName = 'dataPatient';
    }

    //this.messagingSubscription = this.messagingService.componentMessageCall
    //  .subscribe(response => {
    //    let event = response.event;
    //    let eventData = response.eventData;

    //    if (event === 'Popup-has-opened') {
    //      // tell the new window that it should be in pop-up mode
    //      this.messagingService.sendPopUpMessage('Window-is-Popup', {}, this.notesWindowId);
    //      // now the window is good to go and you can send the init event
    //      // right now the notes pop-up has default values for testing, you simply send the init query to change that
    //      this.sendNotesPopUpInformation();

    //    }
    //  });

  }

  closeNotes() {
    this.messagingService.sendComponentMessage("Toggle-Notes-Display", { display: false });
  }

  //sendNotesPopUpInformation() {
  //  // simulate that a patient has changed
  //  this.messagingService.recursiveBroadCastMessage('Notes-Query', {
  //    clearCurrentQuery: true,
  //    PatientID: '2239CF6E-33E3-E611-8289-001018350ACD',
  //    NoteGroupId: null,
  //    ParentObjectName: 'dataPatient',
  //    PatientName: 'John Smith',
  //    ObjectId: '2239CF6E-33E3-E611-8289-001018350ACD'
  //  });
  //}

  //openNotesInPopup() {
  //  this.isPopupMode = true;
  //  let openToUrl = '/notes/viewer';
  //  let windowOptions = 'toolbar = 0, location = 0, menubar = 0, height = 900, width = 850';
  //  let storageName = 'noteData';
  //  let itemToStore = {};
  //  let postClosureEvents = [];
  //  this.notesWindowId = this.messagingService.openPopUpWindow(openToUrl, windowOptions, storageName, itemToStore, postClosureEvents);


  //}

}
